An opaque cursor to the earlier bounding advertisement brandings.

Resulting advertisement brandings will _succeed_ this cursor.
